import { CRAWLER_PATTERNS } from './useIsCrawler.constants';

const CRAWLER_PATTERN = new RegExp(CRAWLER_PATTERNS.join('|'), 'i');

export const isCrawlerUserAgent = (userAgent: string): boolean => {
  return CRAWLER_PATTERN.test(userAgent);
};
